export const status_page = (data)=>{
    return{
        type: "NEXT_PAGE",
        payload: {data}
    }
}


